class HttpError extends Error {
    constructor(message) {
      super(message);
      this.name = 'HttpError';
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
      }
    }
  }
  
  module.exports = { HttpError };
  